import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@mui/material';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';

interface ActionPage {
  isLoading: boolean;
  id?: number;
  handleSubmit?: (data: any) => any;
}

const styling = {
  buttonStyle: { width: '130px' },
};

export const FormButtons = ({ isLoading, id, handleSubmit }: ActionPage) => {
  const navigate = useNavigate();
  const onCancel = () => {
    if (!id) {
      navigate(`/customers`);
    } else {
      navigate(`/customers/details/${id}`);
    }
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container justifyContent="space-between" spacing={1}>
      <Grid item>
        <Button variant="outlined" style={styling.buttonStyle} onClick={onCancel}>
          Cancel
        </Button>
      </Grid>
      <Grid item>
        {!handleSubmit ? (
          <Button
            type={'submit'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
          >
            Save
          </Button>
        ) : (
          <Button
            type={'button'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            onClick={handleSubmit}
          >
            Save
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
